export default function stubObject() {
  return {}
}
